import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyTravelProductToggleControl = loadable(
  () => import(/* webpackChunkName: "content/travel/product-toggle" */ './TravelProductToggleControl'),
  'TravelProductToggleControl',
);
